/**
 * Module Config
 *
 * Author Matic Kogovšek [kogovsek.matic@gmail.com]
 */
import pck from '../../package.json'

export const localStorageKey = 'tt-backoffice:' + pck.version
